import { jsxs as i, jsx as o } from "react/jsx-runtime";
import { ICONS_COLOR_MAPPING as r } from "./index.es2359.js";
const h = ({ outline: l = "default-gray", size: C = 16 }) => {
  const t = r[l];
  return /* @__PURE__ */ i(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ o(
          "path",
          {
            d: "M10 2.5C10 3.32843 9.32843 4 8.5 4C7.67157 4 7 3.32843 7 2.5C7 1.67157 7.67157 1 8.5 1C9.32843 1 10 1.67157 10 2.5Z",
            fill: t
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M10 9C10 9.82843 9.32843 10.5 8.5 10.5C7.67157 10.5 7 9.82843 7 9C7 8.17157 7.67157 7.5 8.5 7.5C9.32843 7.5 10 8.17157 10 9Z",
            fill: t
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M8.5 17C9.32843 17 10 16.3284 10 15.5C10 14.6716 9.32843 14 8.5 14C7.67157 14 7 14.6716 7 15.5C7 16.3284 7.67157 17 8.5 17Z",
            fill: t
          }
        )
      ]
    }
  );
};
export {
  h as UtilityMoreIcon
};
//# sourceMappingURL=index.es440.js.map
